import HelpOutlineIcon from "@mui/icons-material/HelpOutlineRounded";
import { Stack, Tooltip } from "@mui/material";
import StatusChip from "@entrilia/shared/components/StatusChip";
import useClientContext from "../../../../context/useClientContext";
import CategoryTag from "../../../common/CategoryTag";

interface Props {
  categoryId: string | undefined;
}

const UserConsentCategoryTag = ({ categoryId }: Props) => {
  const { getAccessCategoryById } = useClientContext();

  if (categoryId === undefined) {
    return <StatusChip label="All categories" color={(t) => t.palette.text.secondary} />;
  }

  if (getAccessCategoryById(categoryId) === undefined) {
    return (
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <StatusChip label="No category" color={(t) => t.palette.text.secondary} neutral />
        <Tooltip title="Category not found or deleted" arrow>
          <HelpOutlineIcon fontSize="small" color="action" />
        </Tooltip>
      </Stack>
    );
  }

  return <CategoryTag categoryId={categoryId} />;
};

export default UserConsentCategoryTag;
